function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgIconQr = function SvgIconQr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    width: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 5.5C4.5 4.94772 4.94772 4.5 5.5 4.5H8.5C9.05228 4.5 9.5 4.94772 9.5 5.5V8.5C9.5 9.05228 9.05228 9.5 8.5 9.5H5.5C4.94772 9.5 4.5 9.05228 4.5 8.5V5.5ZM5 11C3.89543 11 3 10.1046 3 9V5C3 3.89543 3.89543 3 5 3H9C10.1046 3 11 3.89543 11 5V9C11 10.1046 10.1046 11 9 11H5ZM4.5 15.5C4.5 14.9477 4.94772 14.5 5.5 14.5H8.5C9.05228 14.5 9.5 14.9477 9.5 15.5V18.5C9.5 19.0523 9.05228 19.5 8.5 19.5H5.5C4.94772 19.5 4.5 19.0523 4.5 18.5V15.5ZM5 21C3.89543 21 3 20.1046 3 19V15C3 13.8954 3.89543 13 5 13H9C10.1046 13 11 13.8954 11 15V19C11 20.1046 10.1046 21 9 21H5ZM19.5 5.5C19.5 4.94772 19.0523 4.5 18.5 4.5H15.5C14.9477 4.5 14.5 4.94772 14.5 5.5V8.5C14.5 9.05228 14.9477 9.5 15.5 9.5H18.5C19.0523 9.5 19.5 9.05228 19.5 8.5V5.5ZM15 3C13.8954 3 13 3.89543 13 5V9C13 10.1046 13.8954 11 15 11H19C20.1046 11 21 10.1046 21 9V5C21 3.89543 20.1046 3 19 3H15ZM14.5 13H13V17.5H15.5V19.5H13V21H14.5V19.5H15.5H17V21H21V17.5H18.5V14.5H21V13H17V16H14.5V13ZM18.5 17.5H17V19.5H19.5V17.5H18.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 16,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 6,
    width: 2,
    height: 2
  }));
};
export default SvgIconQr;